import { render, staticRenderFns } from "./InstancesLayout.vue?vue&type=template&id=e38b346c"
import script from "./InstancesLayout.vue?vue&type=script&lang=ts"
export * from "./InstancesLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports